import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Refresh14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75003 1H1.25003V5.75H6.00003V4.25H3.75955C4.5401 3.33114 5.70212 2.75 7.00006 2.75C9.34727 2.75 11.2501 4.65279 11.2501 7H12.7501C12.7501 3.82436 10.1757 1.25 7.00006 1.25C5.31588 1.25 3.80079 1.97472 2.75003 3.12704V1Z'
      fill='currentColor'
    />
    <path
      d='M11.25 13H12.75V8.25L8.00003 8.25V9.75H10.2405C9.45997 10.6689 8.29794 11.25 7 11.25C4.65279 11.25 2.75 9.34721 2.75 7H1.25C1.25 10.1756 3.82436 12.75 7 12.75C8.68419 12.75 10.1993 12.0253 11.25 10.873V13Z'
      fill='currentColor'
    />
  </Svg>
);

Refresh14.displayName = 'Refresh14';
export default Refresh14;
